export default __webpack_public_path__ + "static/instagram-dc9bbcfbc73eef4bdf00a19459ed221f.png";